import _ from 'lodash';

export const CLASSES = _.map([{
  id: 1,
  mask: 1,
  name: 'Warrior',
  armorTypes: ['misc', 'plate', 'shield'],
  armorType: 'plate',
  icon: 'classicon_warrior',
}, {
  id: 2,
  mask: 2,
  name: 'Paladin',
  armorTypes: ['misc', 'plate', 'shield'],
  armorType: 'plate',
  icon: 'classicon_paladin',
}, {
  id: 3,
  mask: 4,
  name: 'Hunter',
  armorTypes: ['misc', 'mail'],
  armorType: 'mail',
  icon: 'classicon_hunter',
}, {
  id: 4,
  mask: 8,
  name: 'Rogue',
  armorTypes: ['misc', 'leather'],
  armorType: 'leather',
  icon: 'classicon_rogue',
}, {
  id: 5,
  mask: 16,
  name: 'Priest',
  armorTypes: ['misc', 'cloth'],
  armorType: 'cloth',
  icon: 'classicon_priest',
}, {
  id: 6,
  mask: 32,
  name: 'Death Knight',
  armorTypes: ['misc', 'plate'],
  armorType: 'plate',
  icon: 'spell_deathknight_classicon',
}, {
  id: 7,
  mask: 64,
  name: 'Shaman',
  armorTypes: ['misc', 'mail', 'shield'],
  armorType: 'mail',
  icon: 'classicon_shaman',
}, {
  id: 8,
  mask: 128,
  name: 'Mage',
  armorTypes: ['misc', 'cloth'],
  armorType: 'cloth',
  icon: 'classicon_mage',
}, {
  id: 9,
  mask: 256,
  name: 'Warlock',
  armorTypes: ['misc', 'cloth'],
  armorType: 'cloth',
  icon: 'classicon_warlock',
}, {
  id: 10,
  mask: 512,
  name: 'Monk',
  armorTypes: ['misc', 'leather'],
  armorType: 'leather',
  icon: 'classicon_monk',
}, {
  id: 11,
  mask: 1024,
  name: 'Druid',
  armorTypes: ['misc', 'leather'],
  armorType: 'leather',
  icon: 'classicon_druid',
}, {
  id: 12,
  mask: 2048,
  name: 'Demon Hunter',
  armorTypes: ['misc', 'leather'],
  armorType: 'leather',
  icon: 'classicon_demonhunter',
}, {
  id: 13,
  mask: 4096,
  name: 'Evoker',
  armorTypes: ['misc', 'mail'],
  armorType: 'mail',
  icon: 'classicon_evoker',
}], c => {
  return {
    ...c,
    nameSearch: _.toLower(_.camelCase(c.name)),
  };
});

export const CLASS_ID_MAP = _.fromPairs(_.map(CLASSES, c => [c.name, c.id]));
